import React from "react";
import { Trans } from 'react-i18next';

export const DropdownFilter = ({ openedFilterDropdowns, filter, title, toggleDropdown, shouldToggleFilter, children }) => (
	<li className={`filter-expandable ${openedFilterDropdowns[filter] ? " is-expanded" : ""}`}>
			<span className="filter-name"><Trans>{title}</Trans></span>
			{shouldToggleFilter(filter) ? (
				<div className={`expand-btn ${openedFilterDropdowns[filter] ? " is-expanded" : ""}`} onClick={() => toggleDropdown(filter)}></div>
			) : (
				<div className="expand-btn is-expanded disabled"></div>
			)}
			<div className="clearfix"></div>
			<ul className="filter-ul">
					{children}
			</ul>
	</li>
)